// Copilot answer rendering, shared by the full Copilot page and the side
// panel. Same look as the Insight Engine answers (Tailwind classes, brand blue quotes).
import React from "react";

export const md = {
  h1: ({ children }) => <h3 className="text-lg font-bold my-3">{children}</h3>,
  h2: ({ children }) => <h3 className="text-base font-bold my-3">{children}</h3>,
  h3: ({ children }) => <h4 className="text-sm font-bold my-2">{children}</h4>,
  p: ({ children }) => <p className="my-2">{children}</p>,
  ul: ({ children }) => <ul className="list-disc pl-6 my-2">{children}</ul>,
  ol: ({ children }) => <ol className="list-decimal pl-6 my-2">{children}</ol>,
  li: ({ children }) => <li className="my-1">{children}</li>,
  blockquote: ({ children }) => (
    <blockquote
      className="pl-4 my-3 italic text-gray-700 py-3 rounded-r"
      style={{ borderLeft: "4px solid #2E45DA", backgroundColor: "rgba(46, 69, 218, 0.06)" }}
    >
      {children}
    </blockquote>
  ),
  table: ({ children }) => (
    <div className="overflow-x-auto my-2">
      <table className="min-w-full border border-gray-300">{children}</table>
    </div>
  ),
  th: ({ children }) => <th className="border border-gray-300 px-3 py-2 bg-gray-50 font-semibold text-left">{children}</th>,
  td: ({ children }) => <td className="border border-gray-300 px-3 py-2">{children}</td>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">{children}</a>
  ),
  code: ({ children }) => <code className="bg-gray-100 px-1 rounded text-sm">{children}</code>,
  strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
};

